import React,{useState, useEffect} from 'react'
import { Box, Divider, Flex, Image, ListItem, Radio, RadioGroup, Slider, Text, UnorderedList } from '@chakra-ui/react'
import PrimaryInput from '../../components/primary-input'
import { PrimaryButton,Toaster } from '../../components'
import { addVisitFormDetail, getVisitFormDetail } from '../../middleware/services/home/childscreening';
import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import { calculateEDD, formatDate_DD_MM_YYYY, formatDate_YYYY_MM_DD, validationMobileNumber, validationOfNumberWithOnly1Decimal } from '../../auth';
import DatePicker from '../../components/date-picker';
import { set } from 'date-fns';
import DatePickerEDD from '../../components/date-picker-EDD';

const WomenHealthScreen = ({patientid, appointmentid,patientData, onSubmit}) => {
    const { isLoading, showLoader, dismissLoader } = useLoader();
    const {showSuccessToast, showErrorToast} = Toaster();

    const menstrualIssues = [
        { displayName: 'Heavy periods', stateKey: 'heavyPeriods' , detailsKey: 'heavyPeriodsDetails'},
        { displayName: 'Irregular periods', stateKey: 'irregularPeriods', detailsKey: 'irregularPeriodsDetails' },
        { displayName: 'Painful periods (dysmenorrhea)', stateKey: 'painfulPeriods', detailsKey: 'painfulPeriodsDetails' },
        { displayName: 'Missed periods (amenorrhea)', stateKey: 'missedPeriods', detailsKey: 'missedPeriodsDetails' },
        { displayName: 'Menorrhagia (Prolonged Bleeding)', stateKey: 'menorrhagia' , detailsKey: 'menorrhagiaDetails'},
      ];
      const menopausalSymptoms = [
        { displayName: 'Hot flashes', stateKey: 'hotFlashes' },
        { displayName: 'Night sweats', stateKey: 'nightSweats' },
        { displayName: 'Mood swings', stateKey: 'moodSwings' },
        { displayName: 'Vaginal dryness', stateKey: 'vaginalDryness' },
        { displayName: 'Sleep disturbances', stateKey: 'sleepDisturbances' },
      ];
    const [formState, setFormState] = useState({
        regularPeriods: '',
        menstrualDetails:'',
        heavyPeriods: '',
        irregularPeriods: '',
        painfulPeriods: '',
        missedPeriods: '',
        menorrhagia: '',
        married: '',
        pregnant: '',
        pregnancyWeeks: '',
        numPregnancies: '',
        numLiveBirths: '',
        miscarriages: '',
        miscarriageDetails: '',
        gynecologicalConditions: '',
        gynecologicalConditionDetails: '',
        papSmear: '',
        papSmearDetails: '',
        abnormalPapSmear: '',
        hpvVaccination: '',
        stds: '',
        stdDetails: '',
        breastexaminations:'',
        mammogram:'',
        mammogramdetails:'',
        breastchanges :'',
        breastchangedetails :'',
        contraceptives: '',
        contraceptiveDetails: '',
        infertility: '',
        infertilityDetails: '',
        menopause: '',
        menopauseAge: '',
        menopausalSymptoms: {
          hotFlashes: '',
          nightSweats: '',
          moodSwings: '',
          vaginalDryness: '',
          sleepDisturbances: ''
        },
        hrt: '',
        lmp:'',
        lmpDate:'',

        // new description fields
        heavyPeriodsDetails: '',
        irregularPeriodsDetails: '',
        painfulPeriodsDetails: '',
        missedPeriodsDetails: '',
        menorrhagiaDetails: '',
        // new fields for GPLAD formula
        paraTerm:'',
        delievryTerm:'',

      });
      let inputForAdd = {
        "patientid": patientid,
        "visitid": appointmentid,
        "visitformdata": [
            // Women's Preventive Health Screening - Menstrual Health
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.1,
                "subsectionname": "Menstrual Health",
                "question": "Do you have regular menstrual periods?",
                "subquestion": null,
                "nestedquestion": null,
                // "value": formState.heavyPeriods,
                "value": formState.regularPeriods ? formState.regularPeriods : 'No',
                "description": formState.menstrualDetails,
            },
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.1,
                "subsectionname": "Menstrual Health",
                "question": "Have you experienced any of the following menstrual issues?",
                "subquestion": "Heavy periods",
                "nestedquestion": null,
                "value": formState.heavyPeriods ? formState.heavyPeriods : 'No',
                "description": formState.heavyPeriodsDetails
            },
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.1,
                "subsectionname": "Menstrual Health",
                "question": "Have you experienced any of the following menstrual issues?",
                "subquestion": "Irregular periods",
                "nestedquestion": null,
                "value": formState.irregularPeriods ? formState.irregularPeriods : 'No',
                "description": formState.irregularPeriodsDetails
            },
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.1,
                "subsectionname": "Menstrual Health",
                "question": "Have you experienced any of the following menstrual issues?",
                "subquestion": "Painful periods (dysmenorrhea): ",
                "nestedquestion": null,
                "value": formState.painfulPeriods ? formState.painfulPeriods : 'No',
                "description": formState.painfulPeriodsDetails
            },
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.1,
                "subsectionname": "Menstrual Health",
                "question": "Have you experienced any of the following menstrual issues?",
                "subquestion": "Missed periods (amenorrhea)",
                "nestedquestion": null,
                "value": formState.missedPeriods ? formState.missedPeriods : 'No',
                "description": formState.missedPeriodsDetails
            },
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.1,
                "subsectionname": "Menstrual Health",
                "question": "Have you experienced any of the following menstrual issues?",
                "subquestion": "Menorrhagia (Prolonged bleeding)",
                "nestedquestion": null,
                "value": formState.menorrhagia ? formState.menorrhagia : 'No',
                "description": formState.menorrhagiaDetails
            },
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.1,
                "subsectionname": "Menstrual Health",
                "question": "Are you married?",
                "subquestion": null,
                "nestedquestion": null,
                "value": formState.married ? formState.married : 'No',
                "description": null
            },
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.1,
                "subsectionname": "Menstrual Health",
                "question": "Are you currently pregnant?",
                "subquestion": null,
                "nestedquestion": null,
                "value": formState.pregnant ? formState.pregnant : 'No',
                "description": formState.pregnancyWeeks,
            },
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.1,
                "subsectionname": "Menstrual Health",
                "question": "LMP (Last Menstrual Period)",
                "subquestion": null,
                "nestedquestion": null,
                "value": formState.lmp ? formState.lmp : 'Unknown',
                "description": formState.lmpDate ? formatDate_YYYY_MM_DD(formState.lmpDate) : null ,
                // "questionnumber":29
            },
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.1,
                "subsectionname": "Menstrual Health",
                "question": "Gravida: How many total pregnancies have you had?",
                "subquestion": null,
                "nestedquestion": null,
                "value": formState.numPregnancies,
                "description": null
            },
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.1,
                "subsectionname": "Menstrual Health",
                "question": "Para: How many pregnancies resulted in the birth of a viable infant?",
                "subquestion": null,
                "nestedquestion": null,
                "value": formState.paraTerm,
                "description": null
            },
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.1,
                "subsectionname": "Menstrual Health",
                "question": "Living: How many children are currently living?",
                "subquestion": null,
                "nestedquestion": null,
                "value": formState.numLiveBirths,
                "description": null
            },
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.1,
                "subsectionname": "Menstrual Health",
                "question": "Abortions: How many pregnancies ended before 20 weeks of gestation?",
                "subquestion": null,
                "nestedquestion": null,
                "value": formState.miscarriages,
                "description": null,
            },
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.1,
                "subsectionname": "Menstrual Health",
                "question": "Delivery: How many pregnancies resulted in deliveries (live births or stillbirths)?",
                "subquestion": null,
                "nestedquestion": null,
                "value": formState.delievryTerm,
                "description": null,
            },
    
            // Gynecological Health
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.2,
                "subsectionname": "Gynecological Health",
                "question": "Have you ever been diagnosed with any gynecological conditions (e.g., PCOS, endometriosis, uterine fibroids)?",
                "subquestion": null,
                "nestedquestion": null,
                "value": formState.gynecologicalConditions ? formState.gynecologicalConditions : 'No',
                "description": formState.gynecologicalConditionDetails,
            },
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.2,
                "subsectionname": "Gynecological Health",
                "question": "Have you undergone a Pap smear test for cervix cancer screening?",
                "subquestion": null,
                "nestedquestion": null,
                "value": formState.papSmear ? formState.papSmear : 'No',
                "description": formState.papSmearDetails,
            },
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.2,
                "subsectionname": "Gynecological Health",
                "question": "Have you ever had an abnormal Pap smear result?",
                "subquestion": null,
                "nestedquestion": null,
                "value":  formState.abnormalPapSmear ? formState.abnormalPapSmear : 'No',
                "description": null
            },
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.2,
                "subsectionname": "Gynecological Health",
                "question": "Have you undergone an HPV vaccination?",
                "subquestion": null,
                "nestedquestion": null,
                "value": formState.hpvVaccination ? formState.hpvVaccination : 'No',
                "description": null
            },
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.2,
                "subsectionname": "Gynecological Health",
                "question": "Have you ever been diagnosed with any sexually transmitted diseases (STDs)?",
                "subquestion": null,
                "nestedquestion": null,
                "value": formState.stds ? formState.stds : 'No',
                "description": formState.stdDetails,
            },
    
            // Breast Health
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.3,
                "subsectionname": "Breast Health",
                "question": "Do you perform regular breast self-examinations?",
                "subquestion": null,
                "nestedquestion": null,
                "value": formState.breastexaminations ? formState.breastexaminations : 'No',
                "description": null
            },
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.3,
                "subsectionname": "Breast Health",
                "question": "Have you ever had a mammogram?",
                "subquestion": null,
                "nestedquestion": null,
                "value": formState.mammogram ? formState.mammogram : 'No',
                "description": formState.mammogramdetails,
            },
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.3,
                "subsectionname": "Breast Health",
                "question": "Have you experienced any breast changes (e.g., lumps, pain, discharge)?",
                "subquestion": null,
                "nestedquestion": null,
                "value": formState.breastchanges ? formState.breastchanges : 'No',
                "description": formState.breastchangedetails,
            },
    
            // Reproductive Health and Family Planning
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.4,
                "subsectionname": "Reproductive Health and Family Planning",
                "question": "Are you currently using any contraceptives?",
                "subquestion": null,
                "nestedquestion": null,
                "value": formState.contraceptives ? formState.contraceptives : 'No',
                "description": formState.contraceptiveDetails,
            },
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.4,
                "subsectionname": "Reproductive Health and Family Planning",
                "question": "Have you ever had difficulty conceiving (infertility)?",
                "subquestion": null,
                "nestedquestion": null,
                "value": formState.infertility ? formState.infertility : 'No',
                "description": formState.infertilityDetails,
            },
    
            // Menopause
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.5,
                "subsectionname": "Menopause",
                "question": "Have you entered menopause (cessation of periods for more than 12 months)?",
                "subquestion": null,
                "nestedquestion": null,
                "value": formState.menopause ? formState.menopause : 'No',
                "description": formState.menopauseAge,
            },
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.5,
                "subsectionname": "Menopause",
                "question": "Are you experiencing any of the following menopausal symptoms?",
                "subquestion": "Hot flashes",
                "nestedquestion": null,
                "value": formState.menopausalSymptoms.hotFlashes ? formState.menopausalSymptoms.hotFlashes : 'No',
                "description": null
            },
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.5,
                "subsectionname": "Menopause",
                "question": "Are you experiencing any of the following menopausal symptoms?",
                "subquestion": "Night sweats",
                "nestedquestion": null,
                "value": formState.menopausalSymptoms.nightSweats ? formState.menopausalSymptoms.nightSweats : 'No',
                "description": null
            },
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.5,
                "subsectionname": "Menopause",
                "question": "Are you experiencing any of the following menopausal symptoms?",
                "subquestion": "Mood swings",
                "nestedquestion": null,
                "value": formState.menopausalSymptoms.moodSwings ? formState.menopausalSymptoms.moodSwings : 'No',
                "description": null
            },
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.5,
                "subsectionname": "Menopause",
                "question": "Are you experiencing any of the following menopausal symptoms?",
                "subquestion": "Vaginal dryness",
                "nestedquestion": null,
                "value": formState.menopausalSymptoms.vaginalDryness ? formState.menopausalSymptoms.vaginalDryness : 'No',
                "description": null
            },
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.5,
                "subsectionname": "Menopause",
                "question": "Are you experiencing any of the following menopausal symptoms?",
                "subquestion": "Sleep disturbances",
                "nestedquestion": null,
                "value": formState.menopausalSymptoms.sleepDisturbances ? formState.menopausalSymptoms.sleepDisturbances : 'No',
                "description": null
            },
            {
                "sectionid": 4,
                "sectionname": "Women’s Preventive Health Screening",
                "subsectionid": 4.5,
                "subsectionname": "Menopause",
                "question": "Are you currently taking hormone replacement therapy (HRT)?",
                "subquestion": null,
                "nestedquestion": null,
                "value": formState.hrt ? formState.hrt : 'No',
                "description": null
            },
        ]
    }
    const [EDDDate, setEDDDate] = useState(null);
    //const [GPLADSummary, setGPLADSummary] = useState(null);

    // function calculateEDD(lmpDate) {
    //     if (!lmpDate) {
    //       throw new Error("LMP date is required");
    //     }
      
    //     // Parse the LMP date
    //     const lmp = new Date(lmpDate);
      
    //     // Add 280 days (40 weeks) to the LMP date
    //     const edd = new Date(lmp);
    //     edd.setDate(lmp.getDate() + 280);
      
    //     // Format the EDD date as YYYY-MM-DD (or any preferred format)
    //     const formattedEDD = edd.toISOString().split("T")[0];
        
    //     return formattedEDD;
    // }
    const handleChange = (field, value, subField = null) => {
        // console.log('field: ', field)
        // console.log('value: ', value)
        // console.log('subField: ', subField)
        // console.log('calculatedEDD Date: ', calculateEDD(value))
        if(field == "lmpDate"){
            // formatDate_YYYY_MM_DD(value)
            // setEDDDate(calculateEDD(value))
            const formattedLMPDate = formatDate_YYYY_MM_DD(value); // Format the LMP date
    const calculatedEDD = calculateEDD(formattedLMPDate); // Calculate EDD
    setEDDDate(calculatedEDD); // Update EDDDate state
        }
        // if(field == "eddDate"){
        //     formatDate_YYYY_MM_DD(value)
        //     setEDDDate(calculateEDD(value))
        // }
        // if(field == "numPregnancies" || field == "paraTerm" || field == "numLiveBirths" || field == "miscarriages" || field == "delievryTerm"){
        //     setGPLADSummary(generateSummary(field, value));
        // }
        setFormState((prevState) => {
            const updatedState = subField
                ? {
                      ...prevState,
                      [field]: {
                          ...prevState[field],
                          [subField]: value,
                      },
                  }
                : {
                      ...prevState,
                      [field]: value,
                  };
    
            // Save updated state to local storage
            localStorage.setItem('formState', JSON.stringify(updatedState));
    
            // console.log(updatedState, 'updated State');
            return updatedState;
        });
    };
    useEffect(() => {
        // Retrieve data from local storage
        const storedFormState = JSON.parse(localStorage.getItem("formState")) || {};
        if(storedFormState.lmpDate){
            setEDDDate(calculateEDD(storedFormState.lmpDate));
        }
        // Merge the stored data with the default state
        setFormState((prevState) => ({
          ...prevState,
          ...storedFormState, // Override default values with stored values
          menopausalSymptoms: {
            ...prevState.menopausalSymptoms,
            ...storedFormState.menopausalSymptoms // Handle nested object separately
          }
        }));
      }, []);   
        
    const saveSectionfour = async ()=>{
          // Remove the last 7 objects if patientData.age < 45
            let filteredVisitFormData = inputForAdd.visitformdata;
            if (patientData?.age < 45) {
                filteredVisitFormData = inputForAdd.visitformdata.slice(0, -7);
            }

            // Add question number starting from 1
            // inputForAdd.visitformdata = filteredVisitFormData.map((item, index) => ({
            //     ...item,
            //     questionnumber: index + 1,
            // }));

            // Add question number starting from 1
            let currentIndex = 1; // Start numbering from 1
            inputForAdd.visitformdata = filteredVisitFormData.map((item) => {
                if (item.questionnumber !== undefined) {
                  // If questionnumber exists, skip assigning and continue
                  return item;
                }
                // Assign the next available questionnumber
                return {
                  ...item,
                  questionnumber: currentIndex++,
                };
              });
       // console.log(inputForAdd, " input for add");
        showLoader();
      try{
        var result = await addVisitFormDetail(inputForAdd);
        if(result.output.message == "Successfully Inserted"){
          //showSuccessToast("Details added Successfully!");
          showSuccessToast("Women Screening details have been saved successfully!");
            setTimeout(() => {
            const newActiveComponent = "women-screening";
            onSubmit(newActiveComponent);
            }, 1000);
        }
      
      } catch (error) {
        console.error("Error in home:", error);
      }
      dismissLoader();
        
      }
  return (
    <>
    
      <Flex gap='1rem' flexDir='column' w='100%'>
      {isLoading && <Loader />}
            {/* Women’s Preventive Health Screening start */}
            <Box>
                <Text fontSize='1rem' fontWeight='600'>Menstrual Health</Text>
                <Box display='flex' flexDirection='column'>
                    <Flex gap='1rem' mt='0.875rem' justifyContent='space-between'>
                        <Text fontSize='0.875rem'>Do you have regular menstrual periods?</Text>
                        <RadioGroup
                         colorScheme='green' display='flex' gap='1rem'
                         value={formState.regularPeriods ? formState.regularPeriods : 'No'}
                         onChange={(value) => handleChange('regularPeriods', value)}>
                            <Radio value='Yes'><Text fontSize='0.875rem'>Yes</Text></Radio>
                            <Radio value='No'><Text fontSize='0.875rem'>No</Text></Radio>
                        </RadioGroup>
                    </Flex>
                    {formState.regularPeriods === 'No' && (
                    <PrimaryInput 
                        variant='fullRound'
                        inputPlace='If no, please specify' 
                        inputStyleCss={{mt:'0.875rem',w:{base:'100%',md:'50%'}}} 
                        inputValue={formState.menstrualDetails || ''}
                        onChange={(e) => handleChange('menstrualDetails', e.target.value)}
                        maxLength={250}
                    />
                )}
                </Box>
                <Divider mt='0.75rem'/>
            </Box>
            <Box>
            <Text fontSize="0.875rem">Have you experienced any of the following menstrual issues?</Text>
            <UnorderedList display="flex" flexDir="column" gap="0.5rem">
                {menstrualIssues.map(({ displayName, stateKey, detailsKey }) => (
                <ListItem key={stateKey} m='0' mt={stateKey == 'heavyPeriods' ? 2 : 0}>
                    <Flex justifyContent="space-between" alignItems="center">
                    <Text fontSize="0.875rem">{displayName}:</Text>
                    <RadioGroup
                        colorScheme="green"
                        display="flex"
                        gap="1rem"
                        value={formState[stateKey] ? formState[stateKey] : 'No'} // Use the correct state key
                        onChange={(value) => handleChange(stateKey, value)} // Update using the state key
                    >
                        <Radio value="Yes"><Text fontSize="0.875rem">Yes</Text></Radio>
                        <Radio value="No"><Text fontSize="0.875rem">No</Text></Radio>
                    </RadioGroup>
                    </Flex>
                    {formState[stateKey] === 'Yes' && (
                    <>
                <PrimaryInput 
                    variant='fullRound'
                    inputPlace='If yes, please specify' 
                    inputStyleCss={{mt:'0.875rem',w:{base:'100%',md:'50%'}}}
                    inputValue={formState[detailsKey] || ''}
                    onChange={(e) => handleChange(detailsKey, e.target.value)}
                    maxLength={250}
                />
                </>
                    )}
                </ListItem>
                ))}
            </UnorderedList>
            </Box>
            {/* <Box>
                <Text fontSize='0.875rem'>Have you experienced any of the following menstrual issues?</Text>
                <UnorderedList display='flex' flexDir='column' gap='0.875rem'>
                    <ListItem m='0'>
                        <Flex justifyContent='space-between' alignItems='center'>
                            <Text fontSize="0.875rem">Heavy periods:</Text>
                            <RadioGroup colorScheme='green' display='flex' gap='1rem'
                            >
                                <Radio value='yes'><Text fontSize='0.875rem'>Yes </Text></Radio>
                                <Radio value='no'><Text fontSize='0.875rem'>No</Text></Radio>
                            </RadioGroup>
                        </Flex>
                    </ListItem>
                    <ListItem m='0'>
                        <Flex justifyContent='space-between' alignItems='center'>
                            <Text fontSize="0.875rem">Irregular periods:</Text>
                            <RadioGroup colorScheme='green' display='flex' gap='1rem'>
                                <Radio><Text fontSize='0.875rem'>Yes </Text></Radio>
                                <Radio><Text fontSize='0.875rem'>No</Text></Radio>
                            </RadioGroup>
                        </Flex>
                    </ListItem>
                    <ListItem m='0'>
                        <Flex justifyContent='space-between' alignItems='center'>
                            <Text fontSize="0.875rem">Missed periods (amenorrhea):</Text>
                            <RadioGroup colorScheme='green' display='flex' gap='1rem'>
                                <Radio><Text fontSize='0.875rem'>Yes </Text></Radio>
                                <Radio><Text fontSize='0.875rem'>No</Text></Radio>
                            </RadioGroup>
                        </Flex>
                    </ListItem>
                    <ListItem m='0'>
                        <Flex justifyContent='space-between' alignItems='center'>
                            <Text fontSize="0.875rem">Menorrhagia (Prolong Bleeding):</Text>
                            <RadioGroup colorScheme='green' display='flex' gap='1rem'>
                                <Radio><Text fontSize='0.875rem'>Yes </Text></Radio>
                                <Radio><Text fontSize='0.875rem'>No</Text></Radio>
                            </RadioGroup>
                        </Flex>
                    </ListItem>
                </UnorderedList>
            </Box> */}
             <Divider mt='0.75rem'/>
            <Box display='flex' flexDirection='column'>
                <Flex gap='1rem' mt='0.875rem' justifyContent='space-between'>
                    <Text fontSize='0.875rem'>Are you married?</Text>
                    <RadioGroup colorScheme='green' display='flex' gap='1rem'
                    value={formState.married ? formState.married : 'No'}
                    onChange={(value) => handleChange('married', value)}>
                        <Radio value='Yes'><Text fontSize='0.875rem'>Yes</Text></Radio>
                        <Radio value='No'><Text fontSize='0.875rem'>No</Text></Radio>
                    </RadioGroup>
                </Flex>
            </Box>
            
            {/* <Divider mt='0.75rem'/> */}
            <Box display='flex' flexDirection='column'>
                <Flex gap='1rem' mt='0.875rem' justifyContent='space-between'>
                    <Text fontSize='0.875rem'>Are you currently pregnant?</Text>
                    <RadioGroup colorScheme='green' display='flex' gap='1rem'
                    value={formState.pregnant ? formState.pregnant : 'No'}
                    onChange={(value) => handleChange('pregnant', value)}>
                        <Radio value='Yes'><Text fontSize='0.875rem'>Yes</Text></Radio>
                        <Radio value='No'><Text fontSize='0.875rem'>No</Text></Radio>
                    </RadioGroup>
                </Flex>
                {formState.pregnant === 'Yes' && (
                    <>
                <PrimaryInput 
                    variant='fullRound'
                    inputPlace='If yes, how many weeks?' 
                    inputStyleCss={{mt:'0.875rem',w:{base:'100%',md:'50%'}}}
                    inputValue={formState.pregnancyWeeks || ''}
                    onChange={(e) => handleChange('pregnancyWeeks', e.target.value)}
                    maxLength={250}
                />

                {/* <Divider mt='0.75rem'/> */}
                <Box mt='0.75rem' display='flex' flexDirection='column'>
                    <Flex gap='1rem' mt='0.875rem' justifyContent='space-between'>
                        <Text fontSize='0.875rem'>LMP (Last Menstrual Period) ?</Text>
                        <RadioGroup colorScheme='green' display='flex' gap='1rem'
                        value={formState.lmp ? formState.lmp : 'Unknown'}
                        onChange={(value) => handleChange('lmp', value)}>
                            <Radio value='Known'><Text fontSize='0.875rem'>Known</Text></Radio>
                            <Radio value='Unknown'><Text fontSize='0.875rem'>Unknown</Text></Radio>
                        </RadioGroup>
                    </Flex>
                    {formState.lmp === 'Known' && (
                        <>
                    <Box borderRadius='10px' mt='0.875rem'w={{base:'100%',md:'50%'}}>
                    <DatePicker
                    // disableFutureDates={true}
                    placeholderProp="Date*"
                    leftPos={{ left: "5px" }}
                    datePickerInputStyle={{ borderRadius: "10px" }}
                     onDateChange={(value) => handleChange('lmpDate', value)}
                    defaultDate={formState.lmpDate ? formatDate_DD_MM_YYYY(formState.lmpDate)  : undefined}
                  />
                  
                  </Box>
                  {/* {EDDDate &&<Text w='50%' textAlign='right'><strong>Expected Delivery Date: </strong>{EDDDate}</Text>} */}

                  {EDDDate && (
                    <>
                      <Text w='50%' mt='0.875rem'>
                        {/* <strong>Expected Delivery Date: </strong>{EDDDate} */}
                        <strong>Expected Delivery Date: </strong>
                        <Box borderRadius='10px' mt='0.875rem'w={{base:'100%',md:'100%'}}>

                  <DatePickerEDD
                    // disableFutureDates={true}
                    placeholderProp="Expected Delivery Date*"
                    leftPos={{ left: "5px" }}
                    datePickerInputStyle={{ borderRadius: "10px" }}
                    defaultDate={EDDDate ? EDDDate : undefined}
                    id="EDDDate"
                    onDateChange={setEDDDate}
                    value={EDDDate} 
                  />

                        </Box>
                      </Text>

                  </>
                  )}
                  </>
                )}
                </Box>
               
                </>
            )}
            </Box>
            <Divider mt='0.75rem'/>
          
            <Box display='flex' alignItems='center' justifyContent='space-between' w='100%'>
                <Text fontSize='0.875rem'><strong>Gravida:</strong>How many total pregnancies have you had?</Text>
                <PrimaryInput variant='fullRound' inputPlace='Value' inputStyleCss={{w:'25%'}}
                inputValue={formState.numPregnancies || ''}
                onChange={(e) => handleChange('numPregnancies', validationMobileNumber(e.target.value, 5))}/>
            </Box>
            <Box display='flex' alignItems='center' justifyContent='space-between' w='100%'>
                <Text fontSize='0.875rem'><strong>Para:</strong>How many pregnancies resulted in the birth of a viable infant?</Text>
                <PrimaryInput variant='fullRound' inputPlace='Value' inputStyleCss={{w:'25%'}}
                inputValue={formState.paraTerm || ''}
                onChange={(e) => handleChange('paraTerm', validationMobileNumber(e.target.value, 5))}/>
            </Box>
            {/* <Divider mt='0.75rem'/> */}
            <Box display='flex' alignItems='center' justifyContent='space-between' w='100%'>
                <Text fontSize='0.875rem'><strong>Living:</strong>How many children are currently living?</Text>
                <PrimaryInput variant='fullRound' inputPlace='Value' inputStyleCss={{w:'25%'}}
                inputValue={formState.numLiveBirths || ''}
                onChange={(e) => handleChange('numLiveBirths',  validationMobileNumber(e.target.value, 5))}/>
            </Box>
            {/* <Divider mt='0.75rem'/> */}
            <Box display='flex' flexDirection='column'>
                <Flex gap='1rem' mt='0.875rem' justifyContent='space-between'>
                    <Text fontSize='0.875rem'><strong>Abortions:</strong>How many pregnancies ended before 20 weeks of gestation?</Text>
                    <PrimaryInput variant='fullRound' inputPlace='Value' inputStyleCss={{w:'25%'}}
                inputValue={formState.miscarriages || ''}
                onChange={(e) => handleChange('miscarriages',  validationMobileNumber(e.target.value, 5))}/>
                    {/* <RadioGroup colorScheme='green' display='flex' gap='1rem'
                    value={formState.miscarriages ? formState.miscarriages : 'No'}
                    onChange={(value) => handleChange('miscarriages', value)}>
                        <Radio value='Yes'><Text fontSize='0.875rem'>Yes</Text></Radio>
                        <Radio value='No'><Text fontSize='0.875rem'>No</Text></Radio>
                    </RadioGroup> */}
                </Flex>
                {/* {formState.miscarriages === 'Yes' && (
                <PrimaryInput 
                    variant='fullRound'
                    inputPlace='If yes, please describe' 
                    inputStyleCss={{mt:'0.875rem',w:{base:'100%',md:'50%'}}}
                    inputValue={formState.miscarriageDetails || ''}
                    onChange={(e) => handleChange('miscarriageDetails', e.target.value)}
                    maxLength={250}
                />
            )} */}
            </Box>
            <Box display='flex' alignItems='center' justifyContent='space-between' w='100%'>
                <Text fontSize='0.875rem'><strong>Delivery:</strong>How many pregnancies resulted in deliveries (live births or stillbirths)?</Text>
                <PrimaryInput variant='fullRound' inputPlace='Value' inputStyleCss={{w:'25%'}}
                inputValue={formState.delievryTerm || ''}
                onChange={(e) => handleChange('delievryTerm', validationMobileNumber(e.target.value, 5))}/>
            </Box>
            {/* Women’s Preventive Health Screening end */}       

            <Divider />

            {/* Gynecological Health start */}
            <Box>
                <Text fontSize='1rem' fontWeight='600'>Gynecological Health</Text>
                <Box display='flex' flexDirection='column'>
                    <Flex gap='1rem' mt='0.875rem' flexDir={{base:'column',md:'row'}} justifyContent={{base:'flex-start',md:'space-between'}}>
                        <Text fontSize='0.875rem'>Have you ever been diagnosed with any gynecological conditions (e.g., PCOS, endometriosis, uterine fibroids)?</Text>
                        <RadioGroup colorScheme='green' display='flex' gap='1rem'
                        value={formState.gynecologicalConditions ? formState.gynecologicalConditions : 'No'}
                        onChange={(value) => handleChange('gynecologicalConditions', value)}>
                            <Radio value='Yes'><Text fontSize='0.875rem'>Yes</Text></Radio>
                            <Radio value='No'><Text fontSize='0.875rem'>No</Text></Radio>
                        </RadioGroup>
                    </Flex>
                    {formState.gynecologicalConditions === 'Yes' && (
                    <PrimaryInput 
                        variant='fullRound'
                        inputPlace='If yes, please specify' 
                        inputStyleCss={{mt:'0.875rem',w:{base:'100%',md:'50%'}}}
                        inputValue={formState.gynecologicalConditionDetails || ''}
                        onChange={(e) => handleChange('gynecologicalConditionDetails', e.target.value)}
                        maxLength={250}
                    />
                )}
                </Box>
                <Divider mt='0.75rem'/>
                <Box display='flex' flexDirection='column'>
                <Flex gap='1rem' mt='0.875rem' flexDir={{base:'column',md:'row'}} justifyContent={{base:'flex-start',md:'space-between'}}>
                        <Text fontSize='0.875rem'>Have you undergone a Pap smear test for cervix cancer screening?</Text>
                        <RadioGroup colorScheme='green' display='flex' gap='1rem'
                        value={formState.papSmear ? formState.papSmear : 'No'}
                        onChange={(value) => handleChange('papSmear', value)}>
                            <Radio value='Yes'><Text fontSize='0.875rem'>Yes</Text></Radio>
                            <Radio value='No'><Text fontSize='0.875rem'>No</Text></Radio>
                        </RadioGroup>
                    </Flex>
                    {formState.papSmear === 'Yes' && (
                    <PrimaryInput 
                        variant='fullRound'
                        inputPlace='If yes, when was the last test?' 
                        inputStyleCss={{mt:'0.875rem',w:{base:'100%',md:'50%'}}}
                        inputValue={formState.papSmearDetails || ''}
                        onChange={(e) => handleChange('papSmearDetails', e.target.value)}
                        maxLength={250}
                    />
                )}
                </Box>
                <Divider mt='0.75rem'/>
                <Flex gap='1rem' mt='0.875rem' flexDir={{base:'column',md:'row'}} justifyContent={{base:'flex-start',md:'space-between'}}>
                    <Text fontSize='0.875rem'>Have you ever had an abnormal Pap smear result?</Text>
                    <RadioGroup colorScheme='green' display='flex' gap='1rem'
                    value={formState.abnormalPapSmear ? formState.abnormalPapSmear : 'No'}
                    onChange={(value) => handleChange('abnormalPapSmear', value)}>
                        <Radio value='Yes'><Text fontSize='0.875rem'>Yes</Text></Radio>
                        <Radio value='No'><Text fontSize='0.875rem'>No</Text></Radio>
                    </RadioGroup>
                </Flex>
                <Divider mt='0.75rem'/>
                <Flex gap='1rem' mt='0.875rem' flexDir={{base:'column',md:'row'}} justifyContent={{base:'flex-start',md:'space-between'}}>
                    <Text fontSize='0.875rem'>Have you undergone an HPV vaccination?</Text>
                    <RadioGroup colorScheme='green' display='flex' gap='1rem'
                    value={formState.hpvVaccination ? formState.hpvVaccination : 'No'}
                    onChange={(value) => handleChange('hpvVaccination', value)}>
                        <Radio value='Yes'><Text fontSize='0.875rem'>Yes</Text></Radio>
                        <Radio value='No'><Text fontSize='0.875rem'>No</Text></Radio>
                    </RadioGroup>
                </Flex>
                <Divider mt='0.75rem'/>
                <Box display='flex' flexDirection='column'>
                <Flex gap='1rem' mt='0.875rem' flexDir={{base:'column',md:'row'}} justifyContent={{base:'flex-start',md:'space-between'}}>
                        <Text fontSize='0.875rem'>Have you ever been diagnosed with any sexually transmitted Diseases (STDs)?</Text>
                        <RadioGroup colorScheme='green' display='flex' gap='1rem'
                        value={formState.stds ? formState.stds : 'No'}
                        onChange={(value) => handleChange('stds', value)}>
                            <Radio value='Yes'><Text fontSize='0.875rem'>Yes</Text></Radio>
                            <Radio value='No'><Text fontSize='0.875rem'>No</Text></Radio>
                        </RadioGroup>
                    </Flex>
                    {formState.stds === 'Yes' && (
                    <PrimaryInput 
                        variant='fullRound'
                        inputPlace='If yes, specify' 
                        inputStyleCss={{mt:'0.875rem',w:{base:'100%',md:'50%'}}}
                        inputValue={formState.stdDetails || ''}
                        onChange={(e) => handleChange('stdDetails', e.target.value)}
                        maxLength={250}
                    />
                )}
                </Box>
            </Box>
            {/* Gynecological Health end */}

            <Divider />

            {/* Breast Health start */}
            <Box>
              <Text fontSize='1rem' fontWeight='600'>Breast Health</Text>
              <Flex gap='1rem' mt='0.875rem' flexDir={{base:'column',md:'row'}} justifyContent={{base:'flex-start',md:'space-between'}}>
                    <Text fontSize='0.875rem'>Do you perform regular breast self-examinations?</Text>
                    <RadioGroup colorScheme='green' display='flex' gap='1rem'
                    value={formState.breastexaminations ? formState.breastexaminations : 'No'}
                    onChange={(value) => handleChange('breastexaminations', value)}>
                        <Radio value='Yes'><Text fontSize='0.875rem'>Yes</Text></Radio>
                        <Radio value='No'><Text fontSize='0.875rem'>No</Text></Radio>
                    </RadioGroup>
                </Flex>
                <Divider mt='0.75rem'/>
                <Box display='flex' flexDirection='column'>
                <Flex gap='1rem' mt='0.875rem' flexDir={{base:'column',md:'row'}} justifyContent={{base:'flex-start',md:'space-between'}}>
                        <Text fontSize='0.875rem'>Have you ever had a mammogram?</Text>
                        <RadioGroup colorScheme='green' display='flex' gap='1rem'
                        value={formState.mammogram ? formState.mammogram : 'No'}
                        onChange={(value) => handleChange('mammogram', value)}>
                            <Radio value='Yes'><Text fontSize='0.875rem'>Yes</Text></Radio>
                            <Radio value='No'><Text fontSize='0.875rem'>No</Text></Radio>
                        </RadioGroup>
                    </Flex>
                    {formState.mammogram === 'Yes' && (
                    <PrimaryInput 
                        variant='fullRound'
                        inputPlace='If yes, when was the last one?' 
                        inputStyleCss={{mt:'0.875rem',w:{base:'100%',md:'50%'}}}
                        inputValue={formState.mammogramdetails || ''}
                        onChange={(e) => handleChange('mammogramdetails', e.target.value)}
                        maxLength={250}
                    />
                    )}
                </Box>
                <Divider mt='0.75rem'/>
                <Box display='flex' flexDirection='column'>
                <Flex gap='1rem' mt='0.875rem' flexDir={{base:'column',md:'row'}} justifyContent={{base:'flex-start',md:'space-between'}}>
                        <Text fontSize='0.875rem'>Have you experienced any breast changes (e.g., lumps, pain, discharge)?</Text>
                        <RadioGroup colorScheme='green' display='flex' gap='1rem'
                        value={formState.breastchanges ? formState.breastchanges : 'No'}
                        onChange={(value) => handleChange('breastchanges', value)}>
                            <Radio value='Yes'><Text fontSize='0.875rem'>Yes</Text></Radio>
                            <Radio value='No'><Text fontSize='0.875rem'>No</Text></Radio>
                        </RadioGroup>
                    </Flex>
                    {formState.breastchanges === 'Yes' && (
                    <PrimaryInput 
                        variant='fullRound'
                        inputPlace='If yes, please specify' 
                        inputStyleCss={{mt:'0.875rem',w:{base:'100%',md:'50%'}}}
                        inputValue={formState.breastchangedetails || ''}
                        onChange={(e) => handleChange('breastchangedetails', e.target.value)}
                        maxLength={250}
                    />
                )}
                </Box>
            </Box>
            {/* Breast Health end */}

            <Divider />

            {/* Reproductive Health and Family Planning start */}
            <Box>
              <Text fontSize='1rem' fontWeight='600'>Reproductive Health and Family Planning</Text>
                <Box display='flex' flexDirection='column'>
                <Flex gap='1rem' mt='0.875rem' flexDir={{base:'column',md:'row'}} justifyContent={{base:'flex-start',md:'space-between'}}>
                        <Text fontSize='0.875rem'>Are you currently using any contraceptives?</Text>
                        <RadioGroup colorScheme='green' display='flex' gap='1rem'
                        value={formState.contraceptives ? formState.contraceptives : 'No'}
                        onChange={(value) => handleChange('contraceptives', value)}>
                            <Radio value='Yes'><Text fontSize='0.875rem'>Yes</Text></Radio>
                            <Radio value='No'><Text fontSize='0.875rem'>No</Text></Radio>
                        </RadioGroup>
                    </Flex>
                    {formState.contraceptives === 'Yes' && (
                    <PrimaryInput 
                        variant='fullRound'
                        inputPlace='If yes, which type?' 
                        inputStyleCss={{mt:'0.875rem',w:{base:'100%',md:'50%'}}}
                        inputValue={formState.contraceptiveDetails || ''}
                        onChange={(e) => handleChange('contraceptiveDetails', e.target.value)}
                        maxLength={250}
                    />
                    )}
                </Box>
                <Divider mt='0.75rem'/>
                <Box display='flex' flexDirection='column'>
                <Flex gap='1rem' mt='0.875rem' flexDir={{base:'column',md:'row'}} justifyContent={{base:'flex-start',md:'space-between'}}>
                        <Text fontSize='0.875rem'>Have you ever had difficulty conceiving (infertility)?</Text>
                        <RadioGroup colorScheme='green' display='flex' gap='1rem'
                        value={formState.infertility ? formState.infertility : 'No'}
                        onChange={(value) => handleChange('infertility', value)}>
                            <Radio value='Yes'><Text fontSize='0.875rem'>Yes</Text></Radio>
                            <Radio value='No'><Text fontSize='0.875rem'>No</Text></Radio>
                        </RadioGroup>
                    </Flex>
                    {formState.infertility === 'Yes' && (
                    <PrimaryInput 
                        variant='fullRound'
                        inputPlace='If yes, specify the duration' 
                        inputStyleCss={{mt:'0.875rem',w:{base:'100%',md:'50%'}}}
                        inputValue={formState.infertilityDetails || ''}
                        onChange={(e) => handleChange('infertilityDetails', e.target.value)}
                        maxLength={250}
                    />
                )}
                </Box>
            </Box>
            {/* Reproductive Health and Family Planning end */}

            <Divider />

            {/* Menopause (For women above 45) start */}
            {patientData?.age > 45 &&
            <Box>
              <Text fontSize='1rem' fontWeight='600'>Menopause (For women above 45)</Text>
                <Box display='flex' flexDirection='column'>
                <Flex gap='1rem' mt='0.875rem' flexDir={{base:'column',md:'row'}} justifyContent={{base:'flex-start',md:'space-between'}}>
                        <Text fontSize='0.875rem'>Have you entered menopause (cessation of periods for more than 12 months)?</Text>
                        <RadioGroup colorScheme='green' display='flex' gap='1rem'
                        value={formState.menopause ? formState.menopause : 'No'}
                        onChange={(value) => handleChange('menopause', value)}>
                            <Radio value='Yes'><Text fontSize='0.875rem'>Yes</Text></Radio>
                            <Radio value='No'><Text fontSize='0.875rem'>No</Text></Radio>
                        </RadioGroup>
                    </Flex>
                    {formState.menopause === 'Yes' && (
                    <PrimaryInput 
                        variant='fullRound'
                        inputPlace='If yes, at what age?' 
                        inputStyleCss={{mt:'0.875rem',w:{base:'100%',md:'50%'}}}
                        inputValue={formState.menopauseAge || ''}
                        onChange={(e) => handleChange('menopauseAge', e.target.value)}
                        maxLength={250}
                    />
                )}
                </Box>
                <Divider mt='0.75rem'/>
                <Box>
                <Text fontSize="0.875rem">Have you experienced any of the following menopausal symptoms?</Text>
                <UnorderedList display="flex" flexDir="column" gap="0.5rem">
                    {menopausalSymptoms.map(({ displayName, stateKey }) => (
                    <ListItem key={stateKey} m='0' mt={stateKey == 'hotFlashes' ? 2 : 0}>
                        <Flex justifyContent="space-between" alignItems="center">
                        <Text fontSize="0.875rem">{displayName}:</Text>
                        <RadioGroup
                            colorScheme="green"
                            display="flex"
                            gap="1rem"
                            value={formState.menopausalSymptoms[stateKey] ? formState.menopausalSymptoms[stateKey] : 'No'} // Access nested state
                            onChange={(value) =>
                            handleChange('menopausalSymptoms', value, stateKey) // Update nested field
                            }
                        >
                            <Radio value="Yes"><Text fontSize="0.875rem">Yes</Text></Radio>
                            <Radio value="No"><Text fontSize="0.875rem">No</Text></Radio>
                        </RadioGroup>
                        </Flex>
                    </ListItem>
                    ))}
                </UnorderedList>
                </Box>
                {/* <Box>
                    <Text fontSize='0.875rem'>Are you experiencing any of the following menopausal symptoms?</Text>
                    <UnorderedList display='flex' flexDir='column' gap='0.875rem'>
                        <ListItem m='0'>
                            <Flex justifyContent='space-between' alignItems='center'>
                                <Text fontSize="0.875rem">Hot flashes:</Text>
                                <RadioGroup colorScheme='green' display='flex' gap='1rem'>
                                    <Radio><Text fontSize='0.875rem'>Yes </Text></Radio>
                                    <Radio><Text fontSize='0.875rem'>No</Text></Radio>
                                </RadioGroup>
                            </Flex>
                        </ListItem>
                        <ListItem m='0'>
                            <Flex justifyContent='space-between' alignItems='center'>
                                <Text fontSize="0.875rem">Night sweats:</Text>
                                <RadioGroup colorScheme='green' display='flex' gap='1rem'>
                                    <Radio><Text fontSize='0.875rem'>Yes </Text></Radio>
                                    <Radio><Text fontSize='0.875rem'>No</Text></Radio>
                                </RadioGroup>
                            </Flex>
                        </ListItem>
                       
                        <ListItem m='0'>
                            <Flex justifyContent='space-between' alignItems='center'>
                                <Text fontSize="0.875rem">Mood swings:</Text>
                                <RadioGroup colorScheme='green' display='flex' gap='1rem'>
                                    <Radio><Text fontSize='0.875rem'>Yes </Text></Radio>
                                    <Radio><Text fontSize='0.875rem'>No</Text></Radio>
                                </RadioGroup>
                            </Flex>
                        </ListItem>
                        
                        <ListItem m='0'>
                            <Flex justifyContent='space-between' alignItems='center'>
                                <Text fontSize="0.875rem">Vaginal dryness:</Text>
                                <RadioGroup colorScheme='green' display='flex' gap='1rem'>
                                    <Radio><Text fontSize='0.875rem'>Yes </Text></Radio>
                                    <Radio><Text fontSize='0.875rem'>No</Text></Radio>
                                </RadioGroup>
                            </Flex>
                        </ListItem>
                        
                        <ListItem m='0'>
                            <Flex justifyContent='space-between' alignItems='center'>
                                <Text fontSize="0.875rem">Sleep disturbances:</Text>
                                <RadioGroup colorScheme='green' display='flex' gap='1rem'>
                                    <Radio><Text fontSize='0.875rem'>Yes </Text></Radio>
                                    <Radio><Text fontSize='0.875rem'>No</Text></Radio>
                                </RadioGroup>
                            </Flex>
                        </ListItem>
                    </UnorderedList>
                </Box> */}
                 <Divider mt='0.75rem'/>
                <Box display='flex' flexDirection='column'>
                    <Flex gap='1rem' mt='0.875rem' justifyContent='space-between'>
                        <Text fontSize='0.875rem'>Are you currently taking hormone replacement therapy (HRT)?</Text>
                        <RadioGroup colorScheme='green' display='flex' gap='1rem'
                        value={formState.hrt ? formState.hrt : 'No'}
                        onChange={(value) => handleChange('hrt', value)}>
                            <Radio value='Yes'><Text fontSize='0.875rem'>Yes</Text></Radio>
                            <Radio value='No'><Text fontSize='0.875rem'>No</Text></Radio>
                        </RadioGroup>
                    </Flex>
                </Box>
            </Box>
            }
            {/* Menopause (For women above 45) end */}
        </Flex>
        <Box pos='fixed' w={{base:'100%', md:'calc(100% - 6rem)'}} left={{base:'1px', md:'6rem'}} bottom={{base:'65px', md:'0px'}} p='1rem' bg='white' boxShadow='rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px'>
          <PrimaryButton buttonText='Save' onClick={saveSectionfour} btnStyle={{w:{base:'100%', md:'20%'}, float:'right'}} />
        </Box>
    </>
  )
}

export default WomenHealthScreen